module.exports = __webpack_public_path__ + "img/spore_icon.7eab9e29.svg";